import React, { Component } from 'react';

class EncryptionDocumentation extends Component {
    render() {
        return (
            <div>
              <p>
                When saving a sequence, you can choose to either save it publicly or
                privately. When you choose to save privately, the sequence is encrypted using
                a password you choose.
              </p>
              <p className="sub-header">
                Password
              </p>
              <p>
                Choose a strong password and make note of the password. Your password
                is never stored on the cloud, so this means there is no way to recover
                your password. So it is extremely important that you store your password
                somewhere safe.
              </p>
              <p>
                This password is different from your <b>Metamask</b> password. It is 
                important you remember both of these passwords so that you don't lose work.
              </p>
              <p>
                When encrypting your projects, you can be sure that only you can view your
                projects. Not even Zequencer developers can see your private projects, because
                they are encrypted on your computer.
              </p>
              <p className="sub-header">
                Loading Private Projects
              </p>
              <p>
                If you've saved private projects before, then when you search for projects,
                you will be prompted for your password. 
              </p>
            </div>
        );
    }
}

export default EncryptionDocumentation;
